"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupingSortingEvaluator = void 0;
class GroupingSortingEvaluator {
    async evaluate(submission, activity) {
        const config = activity.config;
        const items = config?.items || [];
        const structured = submission.structuredData;
        let placements = structured?.placements || {};
        if (Object.keys(placements).length === 0 && structured?.sortedBuckets) {
            placements = {};
            for (const [catId, itemIds] of Object.entries(structured.sortedBuckets)) {
                if (Array.isArray(itemIds)) {
                    for (const id of itemIds) {
                        placements[String(id)] = catId;
                    }
                }
            }
        }
        let correctCount = 0;
        const total = items.length;
        for (const item of items) {
            const placedCat = placements[item.id];
            if (placedCat && placedCat === item.category) {
                correctCount++;
            }
        }
        const isCorrect = total > 0 && correctCount === total;
        const score = total > 0 ? Math.round((correctCount / total) * 100) : 100;
        const feedback = isCorrect
            ? `Fantastic sorting! All ${total} items are in the correct groups!`
            : `You sorted ${correctCount} out of ${total} correctly. Keep practising!`;
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                {
                    name: 'Categorization Accuracy',
                    score,
                    maxScore: 100,
                    feedback: `${correctCount} / ${total} correctly grouped`,
                },
            ],
            skills: [
                { key: 'foundation:grouping_sorting', label: 'Grouping & Sorting' },
            ],
            label: 'Sorting Score',
        };
    }
}
exports.GroupingSortingEvaluator = GroupingSortingEvaluator;
